import React, { useEffect, useRef, useState } from "react";
import { useI18n } from "@/context/I18nContext";
import { Globe, Check } from "lucide-react";

export default function LanguageSwitcher() {
  const { lang, setLang, languages, t } = useI18n();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const current = languages.find((l) => l.code === lang);

  useEffect(() => {
    if (!open) return;
    const onDoc = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    const onEsc = (e) => { if (e.key === "Escape") setOpen(false); };
    document.addEventListener("mousedown", onDoc);
    document.addEventListener("touchstart", onDoc);
    document.addEventListener("keydown", onEsc);
    return () => {
      document.removeEventListener("mousedown", onDoc);
      document.removeEventListener("touchstart", onDoc);
      document.removeEventListener("keydown", onEsc);
    };
  }, [open]);

  return (
    <div className="relative" ref={ref}>
      <button
        data-testid="lang-toggle"
        onClick={() => setOpen((v) => !v)}
        aria-label={t("common.language", "Language")}
        className="inline-flex items-center gap-1.5 px-2.5 py-1.5 rounded-full border border-white/15 text-white/70 hover:text-[#00AFFF] hover:border-[#00AFFF]/50 transition-all text-[11px] font-display font-bold uppercase tracking-wider min-h-[40px]"
      >
        <Globe size={12} /> <span className="hidden sm:inline">{current?.flag}</span> {current?.code?.toUpperCase()}
      </button>
      {open && (
        <div data-testid="lang-menu" className="absolute right-0 top-full mt-2 z-50 glass-strong rounded-xl p-2 border border-[#00AFFF]/30 shadow-2xl w-56 max-h-[60vh] overflow-y-auto">
          {languages.map((l) => (
            <button
              key={l.code}
              data-testid={`lang-option-${l.code}`}
              onClick={() => { setLang(l.code); setOpen(false); }}
              className={`w-full flex items-center justify-between gap-2 px-2.5 py-2 rounded-md text-sm text-left transition ${lang === l.code ? "bg-[#00AFFF]/10 text-[#00AFFF]" : "text-white/75 hover:bg-white/5 hover:text-white"}`}
            >
              <span className="flex items-center gap-2"><span>{l.flag}</span> <span className="font-body">{l.name}</span></span>
              {lang === l.code && <Check size={13} />}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
